import React, { useState } from "react";
import { RotateCcw, ShieldAlert } from "lucide-react";

import { Button } from "@/components/ui/Button";
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/components/ui/Popover";

import { PILL_DANGER } from "../constants";
import MenuItem from "./MenuItem";

// The two fleet-wide moves that take the fleet backwards. They sit behind a
// menu of their own so a mis-click on the toolbar cannot reach them.
const DangerMenu = ({ disabled, onFleetRollback, onFleetDowngrade }) => {
    const [open, setOpen] = useState(false);
    const handle = (fn) => () => {
        setOpen(false);
        fn();
    };
    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <Button disabled={disabled} className={PILL_DANGER}>
                    <ShieldAlert size={12} aria-hidden="true" />
                    Roll back…
                </Button>
            </PopoverTrigger>
            <PopoverContent
                align="end"
                side="bottom"
                sideOffset={6}
                collisionPadding={12}
                className="w-72 p-1"
            >
                <MenuItem
                    icon={RotateCcw}
                    label="Roll back RLS across the fleet"
                    hint="Apply a chosen archived RLS version to every dedicated database"
                    onClick={handle(onFleetRollback)}
                />
                <MenuItem
                    icon={RotateCcw}
                    label="Downgrade the schema on every database"
                    hint="Roll back one Alembic revision on every dedicated database"
                    onClick={handle(onFleetDowngrade)}
                />
            </PopoverContent>
        </Popover>
    );
};

export default DangerMenu;
